
import { defineComponent, ref, onMounted, PropType } from 'vue'

export default defineComponent({
  props: {
    src: {
      type: String,
      default: "/"
    },
    iframeId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const loading = ref(false)
    const height = ref(document.documentElement.clientHeight - 94.5 + "px")
    
    onMounted(() => {
      const iframeId = ("#" + props.iframeId).replace(/\//g, "\\/")
      const iframe = document.querySelector(iframeId) as HTMLIFrameElement
      
      // iframe页面loading控制
      if (iframe) {
        loading.value = true
        
        iframe.onload = () => {
          loading.value = false
        }
      }
    })
    
    return {
      loading,
      height
    }
  }
})
